module.exports = __webpack_public_path__ + "static/media/Giao-thong-20.a6dc6836.svg";